import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import { createRequest } from "../../utility";
import {
  fetchElencoProntoSoccorso,
  fetchElencoProntoSoccorsoSuccess,
  fetchElencoProntoSoccorsoFailed,
  fetchCodiciColore,
  fetchCodiciColoreSuccess,
  fetchCodiciColoreFailed,
  fetchFaq,
  fetchFaqSuccess,
  fetchFaqFailed,
  fetchCookiePolicy,
  fetchCookiePolicySuccess,
  fetchCookiePolicyFailed,
  fetchContacts,
  fetchContactsSuccess,
  fetchContactsFailed,
  fetchPrivacyPs,
  fetchPrivacyPsSuccess,
  fetchPrivacyPsFailed,
  preparaListaPs,
} from "./index";
import { notificationCodes, setNotification } from "../notification";
import {
  SAGAS_ELENCO_OSPEDALI_ERROR_TITLE,
  SAGAS_ELENCO_OSPEDALI_ERROR_DESCRIPTION,
  SAGAS_CODICI_COLORE_ERROR_TITLE,
  SAGAS_CODICI_COLORE_ERROR_DESCRIPTION,
  SAGAS_FAQ_ERROR_TITLE,
  SAGAS_FAQ_ERROR_DESCRIPTION,
  SAGAS_COOKIE_POLICY_ERROR_TITLE,
  SAGAS_COOKIE_POLICY_ERROR_DESCRIPTION,
  SAGAS_CONTACTS_ERROR_TITLE,
  SAGAS_CONTACTS_ERROR_DESCRIPTION,
  SAGAS_PRIVACY_PS_ERROR_TITLE,
  SAGAS_PRIVACY_PS_ERROR_DESCRIPTION,
  fetchMessagesSuccess,
  fetchMessagesFailed,
} from "../language";
import { ELENCO_PS_API, CODICI_COLORE_PS_API, FAQ_API, COOKIE_POLICY_API, CONTACTS_API, PRIVACY_PS_API } from "../../apiUrl";

const fetchElencoProntoSoccorsoWorker = (listenerApi) => {
  createRequest(ELENCO_PS_API.method, ELENCO_PS_API.baseUrl, ELENCO_PS_API.apiUrl + "_" + navigator.language.slice(0, 2) + ".json")
    .then((response) => {
      if (response.status === 200) listenerApi.dispatch(fetchElencoProntoSoccorsoSuccess(preparaListaPs(response.data)));
      else throw response.message;
    })
    .catch((e) => {
      listenerApi.dispatch(setNotification({ tipo: notificationCodes.ERROR, message: SAGAS_ELENCO_OSPEDALI_ERROR_TITLE, description: SAGAS_ELENCO_OSPEDALI_ERROR_DESCRIPTION })); //prettier-ignore
      listenerApi.dispatch(fetchElencoProntoSoccorsoFailed());
    });
};

const fetchCodiciColoreWorker = (listenerApi) => {
  const locale = listenerApi.getState().language?.locale;
  const codiciColore = new Map(JSON.parse(listenerApi.getState().prontoSoccorso.codiciColore.data)).get(locale);
  if (codiciColore == null) {
    createRequest(CODICI_COLORE_PS_API.method, CODICI_COLORE_PS_API.baseUrl, CODICI_COLORE_PS_API.apiUrl + "_" + locale.slice(0, 2) + ".json")
      .then((response) => {
        if (response.status === 200) listenerApi.dispatch(fetchCodiciColoreSuccess({ locale: locale, data: response.data }));
        else throw response.message;
      })
      .catch((e) => {
        listenerApi.dispatch(setNotification({ tipo: notificationCodes.ERROR, message: SAGAS_CODICI_COLORE_ERROR_TITLE, description: SAGAS_CODICI_COLORE_ERROR_DESCRIPTION })); //prettier-ignore
        listenerApi.dispatch(fetchCodiciColoreFailed());
      });
  }
};

const fetchFaqWorker = (listenerApi) => {
  const locale = listenerApi.getState().language?.locale;
  const faq = new Map(JSON.parse(listenerApi.getState().prontoSoccorso.faq.data)).get(locale);
  if (faq == null) {
    createRequest(FAQ_API.method, FAQ_API.baseUrl, FAQ_API.apiUrl + "_" + locale.slice(0, 2) + ".html")
      .then((response) => {
        if (response.status === 200) listenerApi.dispatch(fetchFaqSuccess({ locale: locale, data: response.data }));
        else throw response.message;
      })
      .catch((e) => {
        listenerApi.dispatch(setNotification({ tipo: notificationCodes.ERROR, message: SAGAS_FAQ_ERROR_TITLE, description: SAGAS_FAQ_ERROR_DESCRIPTION })); //prettier-ignore
        listenerApi.dispatch(fetchFaqFailed());
      });
  }
};

const fetchCookiePolicyWorker = (listenerApi) => {
  const locale = listenerApi.getState().language?.locale;
  const cookiePolicy = new Map(JSON.parse(listenerApi.getState().prontoSoccorso.cookiePolicy.data)).get(locale);
  if (cookiePolicy == null) {
    createRequest(COOKIE_POLICY_API.method, COOKIE_POLICY_API.baseUrl, COOKIE_POLICY_API.apiUrl + "_" + locale.slice(0, 2) + ".html")
      .then((response) => {
        if (response.status === 200) listenerApi.dispatch(fetchCookiePolicySuccess({ locale: locale, data: response.data }));
        else throw response.message;
      })
      .catch((e) => {
        listenerApi.dispatch(setNotification({ tipo: notificationCodes.ERROR, message: SAGAS_COOKIE_POLICY_ERROR_TITLE, description: SAGAS_COOKIE_POLICY_ERROR_DESCRIPTION })); //prettier-ignore
        listenerApi.dispatch(fetchCookiePolicyFailed());
      });
  }
};

const fetchContactsWorker = (listenerApi) => {
  const locale = listenerApi.getState().language?.locale;
  const contacts = new Map(JSON.parse(listenerApi.getState().prontoSoccorso.contacts.data)).get(locale);
  if (contacts == null) {
    createRequest(CONTACTS_API.method, CONTACTS_API.baseUrl, CONTACTS_API.apiUrl + "_" + locale.slice(0, 2) + ".html")
      .then((response) => {
        if (response.status === 200) listenerApi.dispatch(fetchContactsSuccess({ locale: locale, data: response.data }));
        else throw response.message;
      })
      .catch((e) => {
        listenerApi.dispatch(setNotification({ tipo: notificationCodes.ERROR, message: SAGAS_CONTACTS_ERROR_TITLE, description: SAGAS_CONTACTS_ERROR_DESCRIPTION })); //prettier-ignore
        listenerApi.dispatch(fetchContactsFailed());
      });
  }
};

const fetchPrivacyPsWorker = (listenerApi) => {
  const locale = listenerApi.getState().language?.locale;
  const privacyPs = new Map(JSON.parse(listenerApi.getState().prontoSoccorso.privacyPs.data)).get(locale);
  if (privacyPs == null) {
    createRequest(PRIVACY_PS_API.method, PRIVACY_PS_API.baseUrl, PRIVACY_PS_API.apiUrl + "_" + locale.slice(0, 2) + ".html")
      .then((response) => {
        if (response.status === 200) listenerApi.dispatch(fetchPrivacyPsSuccess({ locale: locale, data: response.data }));
        else throw response.message;
      })
      .catch((e) => {
        listenerApi.dispatch(setNotification({ tipo: notificationCodes.ERROR, message: SAGAS_PRIVACY_PS_ERROR_TITLE, description: SAGAS_PRIVACY_PS_ERROR_DESCRIPTION })); //prettier-ignore
        listenerApi.dispatch(fetchPrivacyPsFailed());
      });
  }
};

export const prontoSoccorsoMiddleware = createListenerMiddleware();

prontoSoccorsoMiddleware.startListening({
  actionCreator: fetchElencoProntoSoccorso,
  effect: async (action, listenerApi) => fetchElencoProntoSoccorsoWorker(listenerApi),
});

prontoSoccorsoMiddleware.startListening({
  matcher: isAnyOf(fetchMessagesSuccess, fetchMessagesFailed),
  effect: async (action, listenerApi) => {
    listenerApi.dispatch(fetchCodiciColore());
    listenerApi.dispatch(fetchFaq());
    listenerApi.dispatch(fetchCookiePolicy());
    listenerApi.dispatch(fetchPrivacyPs());
    listenerApi.dispatch(fetchContacts());
  },
});

prontoSoccorsoMiddleware.startListening({
  actionCreator: fetchCodiciColore,
  effect: async (action, listenerApi) => fetchCodiciColoreWorker(listenerApi),
});

prontoSoccorsoMiddleware.startListening({
  actionCreator: fetchFaq,
  effect: async (action, listenerApi) => fetchFaqWorker(listenerApi),
});

prontoSoccorsoMiddleware.startListening({
  actionCreator: fetchCookiePolicy,
  effect: async (action, listenerApi) => fetchCookiePolicyWorker(listenerApi),
});

prontoSoccorsoMiddleware.startListening({
  actionCreator: fetchContacts,
  effect: async (action, listenerApi) => fetchContactsWorker(listenerApi),
});

prontoSoccorsoMiddleware.startListening({
  actionCreator: fetchPrivacyPs,
  effect: async (action, listenerApi) => fetchPrivacyPsWorker(listenerApi),
});
